import { render, staticRenderFns } from "./GalleryComponentCard.vue?vue&type=template&id=ff99233a&scoped=true"
import script from "./GalleryComponentCard.vue?vue&type=script&lang=js"
export * from "./GalleryComponentCard.vue?vue&type=script&lang=js"
import style0 from "./GalleryComponentCard.vue?vue&type=style&index=0&id=ff99233a&prod&scoped=true&lang=css"
import style1 from "./GalleryComponentCard.vue?vue&type=style&index=1&id=ff99233a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff99233a",
  null
  
)

export default component.exports